<template>
  <div>
    <v-row style="width:100%;" no-gutters>
      <v-col
        cols="12"
        sm="12"
        style="padding: 5px 10px;"
      >
        <v-textarea
          v-model="data"
          outlined
          label="data"
          hide-details
          append-icon="mdi-send"
          rows="16"
          row-height="90"
          @click:append="handlePrepareData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 5px 10px;"
      >
        <v-textarea
          v-model="token"
          outlined
          label="token"
          hide-details
          color="red"
          append-icon="mdi-send"
          @click:append="handlePrepareToken"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 5px 10px;"
      >
        <small>Decode</small>
        <pre id="json-container">{{prepareJSON(decoded)}}</pre>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 5px 10px;"
        v-if="token"
      >
        <small style="margin-bottom:10px;">URLs</small>
        <p><v-icon @click="handleCopy(`https://widgets.dviewcontent.com/collage/t=${token}`)" style="margin-right: 10px;">mdi-content-copy</v-icon>{{`https://widgets.dviewcontent.com/collage/t=${token}`}}</p>
        <p><v-icon @click="handleCopy(`http://localhost:8009/?t=${token}`)" style="margin-right: 10px;">mdi-content-copy</v-icon>{{`http://localhost:8009/?t=${token}`}}</p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import api from '@/services/api'
import axios from 'axios'
export default {
  data: () => ({
    data: null,
    token: null,
    decoded: null,
  }),
  mounted () {
    this.data = JSON.stringify(JSON.parse('{}'))
    //this.decoded = JSON.stringify(miObjeto, null, 2);
  },
  methods: {
    prepareJSON (v) {
      if (!v) return
      const aux = typeof v === 'string' ? JSON.parse(v) : v
      return JSON.stringify(aux, null, 2)
    },
    handlePrepareToken () {
      axios.get(`https://cm-dviewcontent-api.dviewcontent.com/query/${this.token}`)
        .then(response => {
          this.data = JSON.stringify(response.data, null, 2)
          this.decoded = JSON.stringify(response.data, null, 2)
        })
    },
    handlePrepareData () {
      try {
        const body = JSON.parse(this.data)
        api.put('dviewcontent', 'v1/system/query', body)
          .then(response => {
            this.token = response && response.data ? response.data.token : ''
          })
      } catch (error) {
        alert('error')
        console.log(error)
      }
      /*
      api.put(this.environment, 'v1/system/logs/access', filter)
        .then(response => {
          console.log(response)
        })
      */
      this.decoded = this.data.split(' ').join('')
    },
    async handleCopy (v) {
      try {
        await navigator.clipboard.writeText(v)
        alert('Copiado')
      } catch (err) {
        console.error('Copy error: ', err)
      }
    },
  },
}
</script>
